import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  notification,
  Skeleton,
  Tooltip,
  Typography,
  message,
  Badge,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import {
  CommandBar,
  MessageBar,
  MessageBarType,
  SearchBox,
} from "@fluentui/react";
import React, { createContext, useContext, useEffect, useRef } from "react";
import MonthlysettingStore from "../store/monthlysettingstore";
import { observer } from "mobx-react-lite";
import Modal from "antd/lib/modal/Modal";
import "../style/HierarchyContainer.css";
import { RefreshCcw } from "react-feather";
const monthlySettingStoreCtx = createContext(MonthlysettingStore);
const { Title } = Typography;

export const HierarchyContainer = observer(() => {
  const hierarchyGrid = useRef(null);
  const monthlySettingStore = useContext(monthlySettingStoreCtx);
  useEffect(() => {
    async function loadHierarchy() {
      try {
        if (monthlySettingStore.hierarchy.size === 0) {
          await monthlySettingStore.loadHierarchy();
        }
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `hirerachy loading failed`,
        });
      } finally {
        monthlySettingStore.isloading = false;
      }
    }
    loadHierarchy();
  }, []);

  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
      },
      {
        rowDrag: true,

        width: 70,
        hide: true,
      },
      {
        headerName: "Hierarchy ID",
        field: "uniqueId",
        width: 150,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Field",
        field: "field",
        width: 100,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Well",
        field: "well",
        width: 80,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Level",
        field: "level",
        width: 100,
        resizable: true,
        sortable: true,
      },
    ],
  };

  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{
        borderRight: "1px solid #F0F2F5",
        marginRight: "5px",
        padding: "5px",
      }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Title
            level={4}
            style={{
              display: "inline-block",
              marginRight: "5px",
              fontSize: "16px",
              color: "red",
            }}
          >
            NAOC Asset Hierarchy{" "}
          </Title>
        </div>
      </div>

      <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12">
          <MessageBar messageBarType={MessageBarType.warning}>
            Production hierarchy data is unique and duplicates are not allowed
          </MessageBar>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "refresh",
                text: (
                  <Tooltip title="Refresh daily production data">
                    Refresh
                  </Tooltip>
                ),

                onRenderIcon: () => <RefreshCcw className="qicon" />,

                onClick: async () => {
                  await monthlySettingStore.loadHierarchy();
                },
              },

              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the hierarchy data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        hierarchyGrid.current.api.setQuickFilter(searchTerms);
                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
            ]}
            farItems={[
              {
                key: "filtert3t",
                onRenderIcon: () => (
                  <FileExcelOutlined color="green" style={{ color: "green" }} />
                ),
                text: `Export Hierarchy`,
                onClick: () => {
                  hierarchyGrid.current.api.exportDataAsExcel({
                    sheetName: "Production Hierarchy",
                    allColumns: true,

                    skipFooters: false,
                    skipGroups: false,
                    skipHeader: false,
                    skipPinnedTop: false,
                    skipPinnedBottom: false,
                    fileName: `Production Hierarchy`,
                  });
                },
              },
            ]}
          />
        </div>
      </div>

      {monthlySettingStore.isloading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <div
              className="ag-theme-balham qikreach-grid-fill"
              style={{
                minHeight: "40vh",
                height: "80vh",
                width: "100%",
              }}
            >
              <AgGridReact
                rowData={[...monthlySettingStore.hierarchy.values()]}
                ref={hierarchyGrid}
                gridOptions={{
                  defaultColDef: {
                    sortable: true,
                    filter: true,
                    enableValue: true,
                  },

                  rowSelection: "single",
                  pagination: true,
                  columnDefs: gridcolumnDefs.columnDefs,
                  animateRows: true,

                  columnTypes: {
                    nonEditableColumn: { editable: false },
                  },
                }}
                rowSelection={{ mode: "singleRow", checkboxes: true, enableClickSelection: true }}
                copyHeadersToClipboard={true}
                overlayLoadingTemplate={`${(
                  <span class="ag-overlay-loading-center">
                    Please wait while your rows are loading
                  </span>
                )}`}
                overlayNoRowsTemplate={
                  '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
                }
              ></AgGridReact>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

